export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10935.a37e8cdb.jpg";